import React, { useEffect } from 'react';
import { Avatar, Button, Card, Col, Form, Input, List, Modal, PageHeader, Row, Space, Statistic, Table, Tabs, Typography } from 'antd';
import { Provider } from 'jotai';
import { useMediaQuery } from 'react-responsive';
import { useModalSolicitarPremio, usePuntosPage } from './hooks';
import { ArrowDownOutlined, ArrowUpOutlined, StarOutlined } from "@ant-design/icons"
import { saveAs } from "file-saver";
import logotipo from "../../../assets/imagenes/logotipo.png";
import { PuntosService } from 'services/comunicacion-cultura';

const PuntosPage = () => {

    const esDesktop = useMediaQuery({ query: "(min-width: 860px)" });
    const esMovil = useMediaQuery({ query: "(max-width: 860px)" });

    return (
        <Provider>
            {esDesktop && <PuntosWeb />}
            {esMovil && <PuntosMovil />}
            <ModalSolicitarPremio />
        </Provider>
    );
};

const PuntosWeb = () => {

    const { puntos, resumen, fetchResumen, fetchPuntos } = usePuntosPage();

    // useEffect(() => {
    //     fetchPuntos();
    //     fetchResumen();
    // }, []);

    const { abrirModal: abrirModalSolicitarPremio } = useModalSolicitarPremio();

    const columnas = [
        {
            title: "Año",
            dataIndex: "anio",
            width: '10%',
        },
        {
            title: "Semana",
            dataIndex: "semana",
            width: '10%',
        },
        {
            title: "Puntos Obtenidos",
            dataIndex: "puntosObtenidos",
            width: '10%',
        },
        {
            title: "Puntos Canejados",
            dataIndex: "puntosCanjeados",
            width: '10%',
        },
        {
            title: "Saldo",
            dataIndex: "saldo",
            width: '10%',
        }
    ];

    return (
        <>
            <PageHeader
                title="Puntos de Colaborador"
                style={{ paddingLeft: "0px" }}
            // extra={[
            //     <Button
            //         key="descargar-catalogo"
            //         type="primary"
            //         onClick={async () => {
            //             saveAs(
            //                 "https://storage.googleapis.com/milegajodigital.com/_default/configuracion/pdf/CAT%C3%81LOGO%20DE%20PREMIOS.pdf",
            //                 "catalogo.pdf"
            //             );
            //         }}
            //     >
            //         Descargar Catálogo
            //     </Button>,
            // ]}
            />

            <div className="card-container">
                <Tabs
                    type="card"
                    items={[
                        { key: 'mis-puntos', label: 'Mis Puntos', children: <ListaBeneficiosWeb /> },
                        { key: 'mis-solicitudes', label: 'Mis Solicitudes', children: <ListaSolicitudesWeb /> }
                    ]}
                    tabBarExtraContent={
                        <Space>
                            <Button
                                key="solicitar-beneficio"
                                type="primary"
                                onClick={abrirModalSolicitarPremio}
                            >
                                Solicitar Premio
                            </Button>
                            <Button
                                key="descargar-catalogo"
                                // type="primary"
                                onClick={async () => {
                                    saveAs(
                                        "https://storage.googleapis.com/milegajodigital.com/_default/configuracion/pdf/CAT%C3%81LOGO%20DE%20PREMIOS.pdf",
                                        "catalogo.pdf"
                                    );
                                }}
                            >
                                Descargar Catálogo
                            </Button>
                        </Space>}
                    destroyInactiveTabPane={true}
                />
            </div>

        </>
    )
}

const ListaBeneficiosWeb = () => {

    const { puntos, resumen, fetchResumen, fetchPuntos } = usePuntosPage();

    useEffect(() => {
        fetchPuntos();
        fetchResumen();
    }, []);

    const columnas = [
        {
            title: "Año",
            dataIndex: "anio",
            width: '10%',
        },
        {
            title: "Semana",
            dataIndex: "semana",
            width: '10%',
        },
        {
            title: "Puntos Obtenidos",
            dataIndex: "puntosObtenidos",
            width: '10%',
        },
        {
            title: "Puntos Canejados",
            dataIndex: "puntosCanjeados",
            width: '10%',
        },
        {
            title: "Saldo",
            dataIndex: "saldo",
            width: '10%',
        }
    ];

    return (
        <>
            <Row gutter={16}>
                <Col span={8}>
                    <Card>
                        <Statistic
                            title="Puntos Obtenidos"
                            value={resumen?.totalPuntosObtenidos}
                            valueStyle={{
                                color: '#3f8600',
                            }}
                            prefix={<ArrowUpOutlined />}
                        />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card>
                        <Statistic
                            title="Puntos Canjeados"
                            value={resumen?.totalPuntosCanjeados}
                            valueStyle={{
                                color: '#cf1322',
                            }}
                            prefix={<ArrowDownOutlined />}
                        />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card>
                        <Statistic
                            title="Saldo de Puntos"
                            value={resumen?.totalSaldo}
                            valueStyle={{
                                color: '#0077b6',
                            }}
                            prefix={<ArrowUpOutlined />}
                        />
                    </Card>
                </Col>
            </Row>
            <Table
                rowKey={(puntos) => puntos.id}
                dataSource={puntos}
                columns={columnas}
                size='small'
                pagination={false}
                style={{
                    marginTop: "15px"
                }}
            />
        </>
    )
}

const ListaSolicitudesWeb = () => {

    const { solicitudesPremios, fetchSolicitudesPremios } = usePuntosPage();

    useEffect(() => {
        fetchSolicitudesPremios();
    }, []);

    const columnas = [
        {
            title: "Fecha",
            dataIndex: "createdAt",
            width: '15%',
        },
        {
            title: "Premio",
            dataIndex: "premio",
        },
        {
            title: "Comentario",
            dataIndex: "comentario",
        },
    ];

    return (
        <Table
            rowKey={(solicitudPremio) => solicitudPremio.id}
            dataSource={solicitudesPremios}
            columns={columnas}
            size='small'
            pagination={false}
            style={{
                marginTop: "15px"
            }}
        />
    )
}

const PuntosMovil = () => {

    const { puntos, resumen, fetchResumen, fetchPuntos } = usePuntosPage();

    useEffect(() => {
        fetchPuntos();
        fetchResumen();
    }, []);

    return (
        <>
            <div className="container-movil-pdf-header" style={{ display: "flex", "justifyContent": "space-between" }}>
                <div>
                    <img
                        src={logotipo}
                        alt=""
                        style={{ height: "36px", marginRight: "10px" }}
                    />
                    Mis Puntos
                </div>
                <div>
                    <Button
                        key="descargar-catalogo"
                        type="primary"
                        onClick={async () => {
                            const respuesta = await PuntosService.obtenerUrlDescargaMovil();
                            window.location.href = `${respuesta.urlDocumento}`;
                        }}
                    >
                        Descargar Catálogo
                    </Button>
                </div>
            </div >
            <div style={{ padding: "10px 15px" }}>
                <Row gutter={16}>
                    <Col span={8}>
                        <Card>
                            <Statistic
                                title="Puntos Obtenidos"
                                value={resumen?.totalPuntosObtenidos}
                                valueStyle={{
                                    color: '#3f8600',
                                }}
                                prefix={<ArrowUpOutlined />}
                            />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card>
                            <Statistic
                                title="Puntos Canjeados"
                                value={resumen?.totalPuntosCanjeados}
                                valueStyle={{
                                    color: '#cf1322',
                                }}
                                prefix={<ArrowDownOutlined />}
                            />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card>
                            <Statistic
                                title="Saldo de Puntos"
                                value={resumen?.totalSaldo}
                                valueStyle={{
                                    color: '#0077b6',
                                }}
                                prefix={<ArrowUpOutlined />}
                            />
                        </Card>
                    </Col>
                </Row>
            </div>
            <List
                itemLayout="horizontal"
                dataSource={puntos}
                renderItem={(item) => (
                    <List.Item style={{ padding: "10px 10px" }}>
                        <List.Item.Meta
                            avatar={
                                <Avatar
                                    style={{ backgroundColor: "#ffd60a" }}
                                    icon={<StarOutlined />}
                                />
                            }
                            title={
                                <div>
                                    <Typography.Text strong>{item.anio}</Typography.Text>
                                    <div style={{ fontSize: 12, color: "#1677ff" }}>
                                        Semana {item.semana}
                                    </div>
                                </div>
                            }
                        />
                        <div style={{ fontSize: "16px", fontWeight: 500, padding: "0px 10px" }}>
                            <ArrowUpOutlined style={{ color: "#3f8600" }} /> {item.puntosObtenidos}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: 500, padding: "0px 10px" }}>
                            <ArrowDownOutlined style={{ color: "#cf1322" }} /> {item.puntosCanjeados}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: 500, padding: "0px 10px" }}>
                            <ArrowUpOutlined style={{ color: "#0077b6" }} /> {item.saldo}
                        </div>
                    </List.Item>
                )}
            />
        </>
    )
}

const ModalSolicitarPremio = () => {

    const [form] = Form.useForm();
    const { open, loading, cerrarModal, guardar } = useModalSolicitarPremio();

    return (
        <Modal
            title="Solicitar Premio"
            centered
            open={open}
            onCancel={() => {
                form.resetFields();
                cerrarModal();
            }}
            onOk={() => guardar(form)}
            okButtonProps={{ loading: loading }}
            okText="Solicitar Premio"
            destroyOnClose={true}
            maskClosable={false}
        >

            <Form form={form} layout="vertical">
                <Form.Item
                    label="Premio"
                    name="premio"
                    rules={[{ required: true, message: "Especifique el premio" }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Comentario"
                    name="comentario"
                >
                    <Input.TextArea
                        rows={3}
                    />
                </Form.Item>

            </Form>

        </Modal>
    )
}


export default PuntosPage;